"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var GroupContext_1 = require("../layout/GroupContext");
var classnames_1 = __importDefault(require("classnames"));
var Button_scss_1 = __importDefault(require("./Button.scss"));
var Button = function (props) {
    var _a;
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    return (react_1.default.createElement("button", { id: props.id ? props.id : undefined, className: (0, classnames_1.default)(Button_scss_1.default['au-btn'], (_a = {},
            _a[Button_scss_1.default['au-btn--secondary']] = (props.mode == "secondary"),
            _a[Button_scss_1.default['au-btn--block']] = (props.size == "block"),
            _a), groupCtx.className, props.className), onClick: props.onClick, disabled: props.disabled, "aria-labelledby": props.describedBy || '', title: props.title || undefined }, props.label));
};
exports.Button = Button;
//# sourceMappingURL=Button.js.map